type OrderAnswerTextProps = {
  /** Отгадка / реакция великана после доставки (GDD `answer`). */
  text: string;
};

/** Текст отгадки в слоте описания (тот же layout, что у загадки). */
export function OrderAnswerText({ text }: OrderAnswerTextProps) {
  return <p className="new-delivery-texts__riddle">{text}</p>;
}
